import React from "react";
import { Table } from "react-materialize";
import Html from "utils/Html";

import TrHead from "components/notify/features/table/tr.head";
import TrContent from "components/notify/features/table/tr.content";
import SelectLimit from "components/notify/features/table/select.limit";
import SelectPage from "components/notify/features/table/select.page";
import ModalRemoveItems from "components/notify/features/table/modal.removeitems";
import ModalAddNewByEmail from "components/notify/features/table/modal.add.email";
import { useNotify } from "context/NotifyContext";
import BtnAddByUser from "../features/table/btn.add.user";
import BtnAddByEmail from "../features/table/btn.add.email";

export default function TableContent({ userData }) {
  const { results } = useNotify();
  let content = "";
  if ("err" in results && results.err === 1) {
    content = (
      <div className="text-error">Fetch request error: {results.err_msg}</div>
    );
  } else if (results.status !== "success") {
    content = (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "150px",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  } else {
    content = (
      <div id="table-content">
        <div id="table-total">
          <div>
            Total :{" "}
            <span id="table-total__number">{results.summary_total}</span>
          </div>
        </div>
        <form id="form-alluser" action="">
          <Table className="highlight" id="table-alluser">
            <thead key="thead">
              <TrHead />
            </thead>
            <tbody key="tbody">
              <TrContent />
            </tbody>
          </Table>
          <input type="hidden" name="changed_items" value="" />
        </form>
        <SelectPage />
      </div>
    );
  }
  return (
    <div id="main-content">
      <div className="row title">
        All Email Notification Settings
        <BtnAddByEmail />
        <BtnAddByUser />
        <SelectLimit />
      </div>
      {content}
      <ModalRemoveItems />
      <ModalAddNewByEmail />
    </div>
  );
}
